import { useEffect } from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';

const FEEDBACK_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSe8FYp4NzLHZqDMjSbqQAabSBTCK0wWSdcvodPPjhzHPmvn6Q/viewform';
const STORAGE_KEY = 'solomonq-feedback-toast-shown';

export function FeedbackToast() {
  useEffect(() => {
    const toastShownCount = Number(localStorage.getItem(STORAGE_KEY) || '0');

    if (toastShownCount >= 1) {
      return;
    }

    const showFeedbackToast = () => {
      toast('Ajutați-ne să îmbunătățim SolomonQ', {
        description: (
          <span className="text-gray-900">
            Nu vă place ceva? Lăsați-ne feedback aici
          </span>
        ),
        action: (
          <Button
            variant="outline"
            className="border-black hover:bg-gray-100"
            onClick={() => {
              window.open(FEEDBACK_FORM_URL, '_blank');
            }}>
            Lăsați feedback
          </Button>
        ),
        duration: 10000,
      });
    };

    const firstToastTimer = setTimeout(
      () => {
        showFeedbackToast();
        const newCount = toastShownCount + 1;
        localStorage.setItem(STORAGE_KEY, newCount.toString());
      },
      2 * 60 * 1000
    ); // 2 minutes

    return () => {
      clearTimeout(firstToastTimer);
    };
  }, []);

  return null;
}
